import styled from 'styled-components';

export const Board = styled.div`
  display: flex;
  grid-column-gap: 20px;
  height: 100%;
`;

export const BoardColumn = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  width: 275px;
  flex-shrink: 0;
`;

export const ColumnTitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;

export const ColumnTitle = styled.div<{ color?: string }>`
  font-size: 16px;
  font-weight: 600;
  margin-right: 16px;
  text-transform: capitalize;
  color: ${({ theme, color }) => color || theme.colors['neutral-100']};
`;

export const ColumnTalentsCount = styled.div`
  font-size: 14px;
`;

export const BoardCards = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  overflow-y: auto;
  gap: 8px;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    width: 6px;
    background-color: ${(props) => props.theme.colors['neutral-40']};
    border-radius: 10px;
  }

  width: 100%;
`;
